import { Backdrop } from '@mui/material'
import '../styles/loader.scss'

const Loader = ({withBackDrop}: {withBackDrop: boolean}) => {
  const loaderDiv = (
    <div
      className="loader"
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        zIndex: 1,
      }}
    ></div>
  )

  if (withBackDrop) {
    return (
      <Backdrop style={{zIndex: 1}} open={true}>
        {loaderDiv}
      </Backdrop>
    )
  } else {
    return loaderDiv
  }
}

export default Loader
